import { render, staticRenderFns } from "./PdTabModalImage.vue?vue&type=template&id=2cd20044&scoped=true&"
import script from "./PdTabModalImage.vue?vue&type=script&lang=ts&"
export * from "./PdTabModalImage.vue?vue&type=script&lang=ts&"
import style0 from "./PdTabModalImage.vue?vue&type=style&index=0&id=2cd20044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd20044",
  null
  
)

export default component.exports